import { render, staticRenderFns } from "./TestingsTree.vue?vue&type=template&id=f348083e"
import script from "./TestingsTree.vue?vue&type=script&lang=ts"
export * from "./TestingsTree.vue?vue&type=script&lang=ts"
import style0 from "./TestingsTree.vue?vue&type=style&index=0&id=f348083e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports